var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-style1-list" },
    _vm._l(_vm.defaultData, function (dataItm, dataIdx) {
      return _c(
        "div",
        {
          key: _vm.parentIndex + "_" + dataIdx,
          staticClass: "list-item",
          class: "show-type__" + dataItm.show_type,
          style: {
            padding:
              _vm.itemStyle.itemPaddingTop +
              "px " +
              _vm.itemStyle.itemPaddingLeft +
              "px",
          },
        },
        [
          dataItm.show_type == 10
            ? [
                _vm.itemStyle.imgPosition === "left"
                  ? _c(
                      "div",
                      { staticClass: "list-item__left list-item__image" },
                      [_c("img", { attrs: { src: dataItm.image, alt: "" } })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.itemStyle.imgPosition === "left"
                  ? _c("div", { staticClass: "flex-box" }, [
                      _c(
                        "div",
                        { staticClass: "list-item__title twolist-hidden" },
                        [
                          _vm.itemStyle.show.includes("category") &&
                          dataItm.category
                            ? _c(
                                "span",
                                {
                                  staticClass: "list-item__category",
                                  style: {
                                    border:
                                      "1px solid " +
                                      _vm.itemStyle.categoryColor,
                                    color: _vm.itemStyle.categoryColor,
                                  },
                                },
                                [_vm._v(_vm._s(dataItm.category.name))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "list-title" }, [
                            _vm._v(_vm._s(dataItm.title)),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.itemStyle.show.includes("viewsNum")
                        ? _c("div", { staticClass: "list-item__footer" }, [
                            _c("span", { staticClass: "list-views" }, [
                              _vm._v(_vm._s(dataItm.views_num) + "次浏览"),
                            ]),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.itemStyle.imgPosition === "right"
                  ? _c("div", { staticClass: "list-item__left flex-box" }, [
                      _c(
                        "div",
                        { staticClass: "list-item__title twolist-hidden" },
                        [
                          _vm.itemStyle.show.includes("category") &&
                          dataItm.category
                            ? _c(
                                "span",
                                {
                                  staticClass: "list-item__category",
                                  style: {
                                    border:
                                      "1px solid " +
                                      _vm.itemStyle.categoryColor,
                                    color: _vm.itemStyle.categoryColor,
                                  },
                                },
                                [_vm._v(_vm._s(dataItm.category.name))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "list-title" }, [
                            _vm._v(_vm._s(dataItm.title)),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.itemStyle.show.includes("viewsNum")
                        ? _c("div", { staticClass: "list-item__footer" }, [
                            _c("span", { staticClass: "list-views" }, [
                              _vm._v(_vm._s(dataItm.views_num) + "次浏览"),
                            ]),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.itemStyle.imgPosition === "right"
                  ? _c("div", { staticClass: "list-item__image" }, [
                      _c("img", { attrs: { src: dataItm.image, alt: "" } }),
                    ])
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm._v(" "),
          dataItm.show_type == 20
            ? [
                _c("div", { staticClass: "list-item__title" }, [
                  _c("span", { staticClass: "list-title" }, [
                    _vm._v(_vm._s(dataItm.title)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "list-item__image" }, [
                  _c("img", { attrs: { src: dataItm.image } }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "list-item__footer" }, [
                  _c("span", { staticClass: "list-views" }, [
                    _vm._v(_vm._s(dataItm.views_num) + "次浏览"),
                  ]),
                ]),
              ]
            : _vm._e(),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }